export enum NotificationVariant {
    BUTTON,
    ICON,
    MOBILE
}
export enum NotificationVariant {
    BUTTON,
    ICON,
    MOBILE
}
